"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var WindowImportResult_1 = require("../model/WindowImportResult");

var WindowImportErrorConverter_1 = require("./WindowImportErrorConverter");

var WindowImportResultConverter_1 = require("./WindowImportResultConverter");

var WindowImportWindowIdentificationConverter_1 = require("./WindowImportWindowIdentificationConverter");
/**
 * @author OPt
 */


var WindowImportResultConverterImpl =
/*#__PURE__*/
function (_WindowImportResultCo) {
  _inherits(WindowImportResultConverterImpl, _WindowImportResultCo);

  function WindowImportResultConverterImpl(errorConverter, winConverter) {
    var _this;

    _classCallCheck(this, WindowImportResultConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowImportResultConverterImpl).call(this));
    _this.errorConverter = errorConverter;
    _this.winConverter = winConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowImportResultConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        id: WindowImportResult_1.WindowImportResult.schema.id.valueOf(conversions.toDocumentReferenceId(source.id)),
        monitorId: WindowImportResult_1.WindowImportResult.schema.monitorId.valueOf(conversions.toClassReferenceId(source.monitorId)),
        filename: WindowImportResult_1.WindowImportResult.schema.filename.valueOfField(source),
        date: conversions.fromDate(source.date),
        result: WindowImportResult_1.WindowImportResult.schema.result.valueOfField(source),
        createdWindows: conversions.asObjectArray(source, 'createdWindows', function (field) {
          return _this2.winConverter.toDocument(field, conversions);
        }),
        errors: conversions.asObjectArray(source, 'errors', function (field) {
          return _this2.errorConverter.toDocument(field, conversions);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new WindowImportResult_1.WindowImportResult(WindowImportResult_1.WindowImportResult.schema.id.valueOf(conversions.toDocumentReferenceId(source.id)), WindowImportResult_1.WindowImportResult.schema.monitorId.valueOf(conversions.toClassReferenceId(source.monitorId)), WindowImportResult_1.WindowImportResult.schema.filename.valueOfField(source), WindowImportResult_1.WindowImportResult.schema.date.valueOf(conversions.toDate(source.date)), WindowImportResult_1.WindowImportResult.schema.result.valueOfField(source), conversions.asObjectList(source, 'createdWindows', function (doc) {
        return _this3.winConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'errors', function (doc) {
        return _this3.errorConverter.toObject(doc, conversions);
      }));
    }
  }]);

  return WindowImportResultConverterImpl;
}(WindowImportResultConverter_1.WindowImportResultConverter);

WindowImportResultConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowImportErrorConverter_1.WindowImportErrorConverter, WindowImportWindowIdentificationConverter_1.WindowImportWindowIdentificationConverter])], WindowImportResultConverterImpl);
exports.WindowImportResultConverterImpl = WindowImportResultConverterImpl;